var _rect, _path, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructionFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8.5,
    width: 24,
    height: 24,
    rx: 4.5,
    fill: "#FFD059",
    stroke: "#FFD059"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5341 15.3636V27H12.7727V17.125H12.7045L9.92045 18.9432V17.2614L12.8239 15.3636H14.5341Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 15,
    height: 15,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_182_5059",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_182_5059",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAACbUlEQVR4nO3cr4sVURjG8edctwiKLIJJg1arTS9aRAw2DWJ1m8F/QxAWo3CboMWkQXDLFddq0b5lyxZ3RRGFZY7pYe9lf8PZmee85/nGN5x34AMzE4YBnHPOOeecc67fUukD7z56fHG7w/LsbOXN5EHpPVFbKH1g16VzSPl+6XNbaTT0Bbj5DCJW8VvWtd9rixf+/JibfRzjZvqMT6V3Raw4yKWtjfO3N7/NDxcxzWN8QcaztIr3pXdGqs9b1nUkvMtjrOYbuNfj3qoa4hlimAMa8qFumD1SeMsyzEwKIMww0AJhTcMogrAmYZRBWFMwNYCwJmBqAmGhYWoEYSFhagZhoWAigLAQMJFAWNUwEUFYlTCRQVhVMC2AsCpgWgJh0jAtgjBJmJZBmBSMQXaSgDHI7gaFMcj+DQJjkMPrFcYgR68XGIMcP8K8yrfKf/lpkOO3joSnOIWlNMV26cOLCwduHQnPMcLLNMXfk1pikMPrBYIZZP96hWAG2d0gEMwgOw0KwQwiAsFaBpGCYO2BZGwAWMYCXihBsHZAxCFYfJBKIFhckMogWDyQSiFYHJDKIVj9IEEgWL0gwSBYfSBBIVg9IMEhmD5IIxBMF6QxCKYH0igE0wFpHIIND2KIuYYDMcSe9Q9iiAPrD8QQR6o4yObps7++5stzsytp7QnOYJI+4F/pfdEq/qvxOw+XrnYpf5+drbyeFN8TNX/bK5ZBxDKIWAYRyyBiGUQsg4hlELEMIpZBxDKIWAYRyyBiGUQsg4hlELEMIpZBxDKIWAYRyyBiGUQsg4hV/p+Bo/yz6/C29LnOOeecc845506m/0AHFJdXUvXXAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionFlag);
export default __webpack_public_path__ + "static/media/InstructionFlag.745fae3c122b58679292899441e91af2.svg";
export { ForwardRef as ReactComponent };